<script>
import {ref, watch} from "vue";
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";
import Swal from "sweetalert2";
import FreeWorld from "@/assets/js/FreeWorld";
import NavbarPage from "@/components/assetComponents/NavbarPage.vue";
import {useRoute} from "vue-router";

export default {
  name: "SearchBy",
  components: {NavbarPage, LoadingPage},
  setup() {
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0

    const route = useRoute();
    let loading = ref(false)
    let input_search = ref(route.params.word)

    // Watch for changes in route.params
    watch(() => route.params,
        (newParams) => {
          input_search.value = newParams.word;
          search();
        },
        { immediate: true } // Optional: immediately invoke the watcher with the initial value
    );

    let products = ref([])


    function search() {

      loading.value = true
      FreeWorld.Heisenberg({word: input_search.value} , 'home_page_search').then((result) => {

        loading.value = false
        products.value = result.data

      }).catch((result) => {

        loading.value = false
        if (result.message == 'Network Error') {
          Swal.fire({
            icon: 'error',
            confirmButtonText: 'تلاش مجدد',
            text: 'لطفا فیلتر شکن را خاموش کرده یا وضعیت اینترنت را برسی کنید',
          }).then((result) => {
            if (result.isConfirmed) {
              search()
            }
          })
        } else {
          Swal.fire({
            icon: 'error',
            confirmButtonText: 'تلاش مجدد',
            text: '!خطای ارتباط با سرور',
          }).then((result) => {
            if (result.isConfirmed) {
              search()
            }
          })
        }
      })

    }
    search()


    const txtoverflow = document.querySelectorAll('.txtoverflow');

    function startAnimation() {
      txtoverflow.forEach(element => {
        element.classList.add('animate');
      });
    }

    function stopAnimation() {
      txtoverflow.forEach(element => {
        element.classList.remove('animate');
      });
    }

    txtoverflow.forEach(element => {
      element.addEventListener('animationstart', startAnimation);
      element.addEventListener('animationend', stopAnimation);
    });

    return {

      loading,
      input_search,
      search,
      products,

    }
  }
}
</script>

<template>

  <LoadingPage v-if="loading"></LoadingPage>

  <div id="main" class="bg-main" :class="loading ? 'activeClass' : '' ">
    <div class="div-top-arrow bg-color d-flex align-items-center ">
      <p>جستجو</p>
      <div onclick="history.back()">
        <img class="svg-arrow" src="../assets/img/back.svg" alt="">
      </div>

    </div>
    <br>
    <br>
    <br>

    <div class="d-flex align-items-center justify-content-between mt-2 flex-row-reverse p-body">

      <div class="div_search">
        <input autofocus v-model="input_search" @keydown.enter="search"
               class="input_search bg-white text-center font-5 rounded-pill" type="text" placeholder="جستجو">
      </div>
    </div>

    <br>

    <div v-if="products.length == 0" class="p-body w-100 d-flex flex-column justify-content-center align-items-center"
         style="height: 60vh">
      <div class="d-flex flex-column align-items-center">
        <img style="width: 70px" src="../assets/img/shop_none.svg" alt="">
        <br>
        <p class="font-5 ">
          در حال حاضر محصولی وجود ندارد...
        </p>
      </div>
    </div>

    <div v-else class="list_products p-body">
      <!--*** محصولات ***-->

      <router-link :to="{name:'DetailsProducts' , params:{sub_cat_id:item.sub_categoris , prod_id:item.id}}"
                   v-for="item in products" :key="item.id"
                   class="animate__animated animate__fadeIn p-2 rounded-shaped text-decoration-none text-black products_custom d-flex justify-content-between mb-2 shadow-costom p-body">

        <div class="position-relative animated-background rounded-4 div_img_products">

          <img v-if="item.pic1 == null " class="img_products rounded-4" src="../assets/img/img-notavalible.jpg" alt="">

          <img v-else class="img_products rounded-4" :src="item.pic1" alt="">

          <div v-if="item.rating_product != null"
               class="div_stars py-1 px-2 rounded-pill d-flex position-absolute shadow-costom align-items-center">

            <img style="width: 1.2em" src="../assets/img/star_gold.svg" alt="">

            <p class="font-5 mx-1 text-center">{{ item.rating_product }}</p>
          </div>

        </div>


        <div class="information_products overflow-hidden">

          <p class="font-5 font-bold" :class="{'txtoverflow':item.name.length > 26}">{{ item.name }}</p>
          <div class="my-1 d-flex justify-content-start align-items-center my-2">
            <div class="d-flex ml-2 overflow-hidden align-items-center">
              <img style="width: 1em" class="ml-2" src="../assets/img/shop.svg" alt="">
              <div class="overflow-hidden">
                <p class="font-5" :class="{'txtoverflow':item.store_name.length > 18}">{{ item.store_name }}</p>
              </div>
            </div>
            <div v-if="item.rating_store != null" class="position-relative">
              <img style="height: 1.5em" src="../assets/img/star_gold.svg" alt="">
              <p class="position-absolute font-5 text-white number_star">{{ item.rating_store }}</p>
            </div>
          </div>
          <div class="my-1 d-flex justify-content-between align-items-center">
            <div class="d-flex">
              <img style="width: 1em" src="../assets/img/list.svg" alt="">
              <p class="font-5 mx-2">{{ item.brand }}</p>
            </div>

            <div v-if="item.count == 0" class="existence rounded-pill">
              <p class="font-color font-5 px-2 py-1">
                ناموجود
              </p>
            </div>
          </div>

          <hr>

          <div class="price_div d-flex justify-content-between">
            <div class="d-flex">

              <p :class="item.off_price != null ? 'text-decoration-line-through' : 'font-color' " class=" font-5">
                <span class="">{{ item.price.toLocaleString() }}</span>

                <span v-if="item.off_price == null" class="mx-1">تومان</span>
              </p>


              <p v-if="item.off_price != null" class="font-5 mx-2 font-color m-0">
                <span class="">{{ item.off_price.toLocaleString() }}</span>

                <span class="mx-1">تومان</span>
              </p>

            </div>


            <p v-if="item.off_price != null" class="off_percent font-5 rounded-pill font-color">
              <span>%</span>
              <span>{{ item.discount }}</span>
            </p>
          </div>
        </div>

      </router-link>

    </div>
    <br>
  </div>

  <div id="web" class="bg-main" :class="loading ? 'activeClass' : '' ">
    <NavbarPage></NavbarPage>
    <div style="background-color: white" class="rounded-4 font-bold font-color p-3 mb-4 w-75 ma-auto">جستجو</div>

    <div style="height: 70vh" class="bg-white rounded-4 w-75 p-4 m-auto overflow-y-scroll">

    <div v-if="products.length == 0" class="w-100 d-flex flex-column justify-content-center align-items-center h-100">
      <div class="d-flex flex-column align-items-center">
        <img style="width: 4rem" src="../assets/img/shop_none.svg" alt="">
        <br>
        <p class="font-5 ">
          در حال حاضر محصولی وجود ندارد...
        </p>
      </div>
    </div>

    <div v-else class="list_products_web">
      <!--*** محصولات ***-->
      <router-link :to="{name:'DetailsProducts' , params:{sub_cat_id:item.sub_categoris , prod_id:item.id}}"
                   v-for="item in products" :key="item.id"
                   class="animate__animated animate__fadeIn rounded-shaped text-decoration-none text-black products_custom_web d-flex justify-content-between mb-3 shadow-costom p-body">

        <div class="position-relative animated-background rounded-4 div_img_products_web">

          <img v-if="item.pic1 == null " class="w-100 h-100 img-cover rounded-4" src="../assets/img/img-notavalible.jpg" alt="">

          <img v-else class="w-100 h-100 img-cover rounded-4" :src="item.pic1" alt="">

          <div v-if="item.rating_product != null"
               class="div_stars py-1 px-2 rounded-pill d-flex position-absolute shadow-costom align-items-center">

            <img style="width: 20px" src="../assets/img/star_gold.svg" alt="">

            <p class="font-5 mx-1 text-center">{{ item.rating_product }}</p>
          </div>

        </div>


        <div class="information_products d-flex flex-column justify-content-evenly overflow-hidden">

          <p class="font-5 font-bold" :class="{'txtoverflow':item.name.length > 30}">{{ item.name }}</p>
          <div class="my-1 d-flex justify-content-start align-items-center">
            <div class="d-flex ml-2 overflow-hidden align-items-center">
              <img style="width: 18px" class="ml-2" src="../assets/img/shop.svg" alt="">
              <div class="overflow-hidden">
                <p class="font-5" :class="{'txtoverflow':item.store_name.length > 25}">{{ item.store_name }}</p>
              </div>
            </div>
            <div v-if="item.rating_store != null" class="position-relative">
              <img style="height: 25px" src="../assets/img/star_gold.svg" alt="">
              <p class="position-absolute font-5 text-white number_star">{{ item.rating_store }}</p>
            </div>
          </div>
          <div class="my-1 d-flex justify-content-between align-items-center">
            <div class="d-flex">
              <img style="width: 18px" src="../assets/img/list.svg" alt="">
              <p class="font-5 mx-2">{{ item.brand }}</p>
            </div>

            <div v-if="item.count == 0" class="existence rounded-pill">
              <p class="font-color font-5 px-2 py-1">
                ناموجود
              </p>
            </div>
          </div>

          <hr>

          <div class="price_div d-flex justify-content-between">
            <div class="d-flex">

              <p :class="item.off_price != null ? 'text-decoration-line-through' : 'font-color' " class=" font-5">
                <span class="">{{ item.price.toLocaleString() }}</span>

                <span v-if="item.off_price == null" class="mx-1">تومان</span>
              </p>


              <p v-if="item.off_price != null" class="font-5 mx-2 font-color m-0">
                <span class="">{{ item.off_price.toLocaleString() }}</span>

                <span class="mx-1">تومان</span>
              </p>

            </div>


            <p v-if="item.off_price != null" class="off_percent font-5 rounded-pill font-color font-bold">
              <span>%</span>
              <span>{{ item.discount }}</span>
            </p>
          </div>
        </div>

      </router-link>

    </div>

  </div>
  </div>

</template>

<style scoped>

.svg-arrow {
  height: 15px;
  margin-left: 10px;
}

p {
  margin: 0;
}

.div_search {
  width: 100%;
  position: relative;

}

.input_search {
  width: 100%;
  height: 4rem;
  border: 1px solid #8C8C8CA0;
}

.products_custom {
  padding:.5rem;
  width: 100%;
  background-color: white;
}

.img_products {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.div_stars {
  left: 50%;
  transform: translate(-50%);
  bottom: -.5rem;
  background-color: white;
  justify-content: center;
}

.off_percent {
  padding: .3rem;
  text-align: center;
  background-color: #d2d2d2;
}

.number_star {
  left: 50%;
  top: 55%;
  transform: translate(-50%, -50%);
}

.div_img_products {
  width: 10rem;
  height: 10rem;
}

.information_products {
  direction: rtl;
  width: calc(100% - 10.5rem);
}

.existence {
  border: 1px solid #8C8C8CA0;
  background-color: #d2d2d2;
}


.list_products_web {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.products_custom_web {
  padding: .8rem;
  background-color: white;
  flex-basis: 48%;
  flex-grow: 1;
  margin: 0 .5rem;
}

.div_img_products_web {
  width: 10rem;
  height: 10rem;
}

</style>